import { AxiosInstance } from "axios";
import { ICore } from "./interfaces";

export function getUpdateCommunicationPreferencesBuilder(
  apiClient: AxiosInstance
) {
  return async function updateCommunicationPreferences(
    id: number,
    value: string | number | boolean
  ): Promise<ICore.ICommPermission> {
    const response = await apiClient.patch(
      `/accounts/notification-permissions/${id}/`,
      {
        value,
      }
    );
    return response.data;
  };
}
